import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import { FeatureFlag } from 'react-launch-darkly';
import BarChart from '../BarChart/BarChart';

const StudentStatus = observer(class StudentStatus extends React.Component {

  renderAssignmentStatus() {
    const { limitedScope, summary, translation } = this.props;
    let assignedStudents = 0;

    if (limitedScope) {
      Object.keys(summary).forEach(status => {
        if(status !== 'Not Assigned'){
          assignedStudents += summary[status];
        }
      })
      return `${assignedStudents} ${translation.students}`;
    } else {
      return translation.course_wide;
    }
  }
  render() {
    const { translation } = this.props;
    let { summary } = this.props;

    if(summary.hasOwnProperty('notAssigned')){
      delete summary.notAssigned
    }

    return (
      <section className="panel__section">
        <div className='panel__heading'>
          <h2>{translation.heading}</h2>
          <FeatureFlag
            flagKey="create-limited-scope-exam"
            renderFeatureCallback={() => {
              return (
                <h2>{translation.assigned_to} {this.renderAssignmentStatus()}</h2>
              )
            }}
            renderDefaultCallback={() => {
              return null;
            }}
            />
        </div>


        <BarChart data={summary} title={translation.chart_title} i={this.props.i} />
      </section>
    )
  }
})

export default translate('StudentStatus')(StudentStatus);



// WEBPACK FOOTER //
// ./src/app/components/Modules/StudentStatus.js